import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/(auth)/register/partner/$")({
    component: PartnerRedirect,
});

function PartnerRedirect() {
    const { _splat } = Route.useParams();
    const cspSlug = (_splat ?? "").split("/").filter(Boolean)[0] || "";
    const navigate = useNavigate();

    useEffect(() => {
        if (cspSlug) {
            navigate({
                to: "/register/$cspSlug",
                params: { cspSlug },
                replace: true,
                search: (prev) => prev,
            });
        } else {
            navigate({ to: "/register", replace: true, search: (prev) => prev });
        }
    }, [cspSlug, navigate]);

    return null;
}
